import axios from "axios";
import router from "../../router/index";

export default {
  async puxarDadosSalvosServidor({ commit, getters }, url) {
    if (getters.getIsFetched) return;
    commit("setFetched", true);

    const { data } = await axios.get(url);

    commit("payloadServidor", data);
  },
  async puxarTiposQuestionarios({ commit }, query) {
    const { data } = await axios.get(query.url);

    if (!data) return;

    const tipoForm = data.find(q => q.tipoQuestionario === query.tipo);

    commit("setTipoQuestionario", tipoForm);

    return tipoForm;
  },
  recuperarIdPrestador({ commit }) {
    const { id } = router.currentRoute.params;

    commit("setIdPrestador", id);
  }
};
